import * as yup from 'yup';
import { ISuggestion, SuggestionSchema } from '../../common';

export const DocumentManagementSuggestionSchema = yup.object({
  documentTypes: SuggestionSchema.nullable(),
});

export type IDocumentManagementSuggestion = {
  documentTypes: ISuggestion;
};
